import { FC } from 'react';
import { Block } from './Zoom.style';

export const Zoom: FC<{ elementsCount?: number }> = ({ children }) => {
  return <Block>{children}</Block>;
};
